module.exports = __webpack_public_path__ + "static/media/shreyas.61e5f507.png";